import type { FacilityFlowCoreCommonDtosAddressDto } from '@/api/generated/models';

export interface AddressInput {
  street?: string | null;
  streetNumber?: string | null;
  city?: string | null;
  postalCode?: string | null;
  country?: string | null;
}

const ADDRESS_PARTS = ['street', 'streetNumber', 'city', 'postalCode', 'country'] as const;

/** True when no part of the address is filled in. */
export function isAddressEmpty(address: AddressInput | null | undefined): boolean {
  return ADDRESS_PARTS.every((part) => !address?.[part]?.trim());
}

/**
 * Request payload for an employee address. The address is optional (employees imported from
 * Excel often have none): an empty address is omitted, a filled one is sent trimmed and must
 * then be complete — the API reports missing parts per field.
 */
export function toAddressPayload(
  address: AddressInput | null | undefined,
): FacilityFlowCoreCommonDtosAddressDto | undefined {
  if (!address || isAddressEmpty(address)) return undefined;

  return {
    street: address.street?.trim() ?? '',
    streetNumber: address.streetNumber?.trim() || null,
    city: address.city?.trim() ?? '',
    postalCode: address.postalCode?.trim() ?? '',
    country: address.country?.trim() ?? '',
  };
}
